import React, { useState } from "react";
import logo from "../assets/lg.png";
import { FaMoon, FaBars, FaTimes } from "react-icons/fa";
import { AiOutlineSun } from "react-icons/ai";

function Header({ darkMode, toggleDarkMode }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return (
    <header className="bg-gray-50 dark:bg-black text-gray-700 dark:text-gray-200 p-4 fixed top-0 w-full shadow-xl opacity-90 z-50 transition-colors duration-300">
      <nav className="container mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <img src={logo} className="h-12" alt="Logo"></img>
          <h1 className="text-2xl font-bold pl-1 text-gray-700 dark:text-white">
            Öznur Çaldıran
          </h1>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-4">
          <ul className="flex space-x-4 items-center">
            <li>
              <a
                href="#home"
                className="hover:text-gray-400 dark:hover:text-gray-300 transition-colors duration-200"
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#about"
                className="hover:text-gray-400 dark:hover:text-gray-300 transition-colors duration-200"
              >
                About
              </a>
            </li>
            <li>
              <a
                href="#projects"
                className="hover:text-gray-400 dark:hover:text-gray-300 transition-colors duration-200"
              >
                Projects
              </a>
            </li>
            <li>
              <a
                href="#skills"
                className="hover:text-gray-400 dark:hover:text-gray-300 transition-colors duration-200"
              >
                Skills
              </a>
            </li>
            <li>
              <a
                href="#blog"
                className="hover:text-gray-400 dark:hover:text-gray-300 transition-colors duration-200"
              >
                Blog
              </a>
            </li>
            <li>
              <a
                href="#contact"
                className="hover:text-gray-400 dark:hover:text-gray-300 transition-colors duration-200"
              >
                Contact
              </a>
            </li>
          </ul>
          <button
            onClick={toggleDarkMode}
            className="p-2 rounded-lg bg-gray-200 dark:bg-gray-900 text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-700 transition-colors duration-200"
            aria-label="Toggle dark mode"
          >
            {darkMode ? (
              <AiOutlineSun className="w-5 h-5" />
            ) : (
              <FaMoon className="w-5 h-5" />
            )}
          </button>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center space-x-2">
          <button
            onClick={toggleDarkMode}
            className="p-2 rounded-lg bg-gray-200 dark:bg-gray-900 text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-700 transition-colors duration-200"
            aria-label="Toggle dark mode"
          >
            {darkMode ? (
              <AiOutlineSun className="w-4 h-4" />
            ) : (
              <FaMoon className="w-4 h-4" />
            )}
          </button>
          <button
            onClick={toggleMenu}
            className="p-2 rounded-lg bg-gray-200 dark:bg-gray-900 text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-700 transition-colors duration-200"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? (
              <FaTimes className="w-5 h-5" />
            ) : (
              <FaBars className="w-5 h-5" />
            )}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 ease-in-out ${
          isMenuOpen
            ? "max-h-96 opacity-100"
            : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        <ul className="container text-end mx-auto px-4 py-2 space-y-2 bg-gray-50 dark:bg-black">
          <li>
            <a
              href="#home"
              className="block border-b border-gray-600 py-2 px-3 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="#about"
              className="block border-b border-gray-600 py-2 px-3 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </a>
          </li>
          <li>
            <a
              href="#projects"
              className="block border-b border-gray-600 py-2 px-3 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              Projects
            </a>
          </li>
          <li>
            <a
              href="#skills"
              className="block border-b border-gray-600 py-2 px-3 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              Skills
            </a>
          </li>
          <li>
            <a
              href="#contact"
              className="block  py-2 px-3 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </a>
          </li>
        </ul>
      </div>
    </header>
  );
}

export default Header;
